interface TitleProps {
    title: string;
}

export const Title = (props: TitleProps) => {
    return <span id="data-panel__title__text">{props.title}</span>
}